import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import { SelectMulti, FormGroup, Label, Col, Row } from 'twyne-new.ui';

import { PageProvider, usePageStore } from '../../store';

const propTypes = {
  value: PropTypes.string,
  show: PropTypes.bool,
  handleChangeContent: PropTypes.func,
}

function PixelTab({ disabled, value, handleChange }) {
  return <PageProvider>
    <Row>
      <Col size="6">
        <FormGroup>
          <Label>Rendering twyne offers pixels</Label>
          <SelectPixels disabled={disabled} value={value} onChange={handleChange} />
        </FormGroup>
      </Col>
    </Row>
  </PageProvider>
}

function SelectPixels({ disabled, value, onChange }) {
  const [options, setOptions] = useState([])
  const { lists: { pixels: { items, useLoad } } } = usePageStore()

  useLoad(PARAMS)

  useEffect(() => {
    if (items) {
      const options = items.map(({ id, name }) => ({ value: id, label: `[#${id}] ${name}` }))
      setOptions(options)
    }
  }, [items])

  return <SelectMulti disabled={disabled} options={options} value={value}
    onChange={options => onChange({ pixels: options.map(({ value }) => value) })} />
}

PixelTab.propTypes = propTypes;
export default PixelTab;

const PARAMS = { type: "twyne_offer", active: true }
